import { useMemo } from "react";
import { Shape } from "../../math/Shape";
import { getLineWidth } from "./util";
const BASE_HEX_LINE_WIDTH = 1;
const createPolygonLayerData = ({ data, lineWidth, }) => ({
    id: 'hex2d-layer',
    data,
    getPolygon: d => d.contour,
    getFillColor: d => typeof d.color === 'string' ? [0, 0, 0] : d.color,
    getLineColor: [40, 40, 40],
    getLineWidth: lineWidth,
});
export const useHex2DLayerData = (props) => {
    const data = useMemo(() => Object.values(props.hexes).map(({ offsetCoords, color, elevation }) => ({
        color,
        elevation,
        contour: Shape.getHexContour(offsetCoords),
    })), [props.hexes]);
    return useMemo(() => createPolygonLayerData({ data, lineWidth: getLineWidth(BASE_HEX_LINE_WIDTH, props.zoom) }), [
        props.zoom,
        data,
    ]);
};
//# sourceMappingURL=hex2DLayer.js.map